/* unplugin-vue-components disabled */
import Column from 'primevue/column'
import {DataTable} from 'components/data-table'
import AddModal from './add-modal.vue'
import EditModal from './edit-modal.vue'
import $topics from 'stores/topics2'

const LIMIT = 20

export default {
  components: {
    AddModal,
    EditModal,
    DataTable,
    Column
  },
  props: {
    tenant: {
      type: Object,
      required: true
    },
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: true,
      load_params: {skip: 0, limit: LIMIT, filter: '', user_id: this.user.id},
    }
  },
  computed: {
    total(){
      return $topics.total
    },
    view_items(){
      return $topics.view_items
    },
    view_total(){
      return $topics.view_total
    },
    refreshing() {
      return $topics.loading
    },
    highlight () {
      return this.load_params.filter
    }
  },
  async mounted() {
    this.loading = true
    await $topics.load(this.load_params)
    this.loading = false
  },
  methods: {
    async onPage(ev){
      this.load_params = {...this.load_params, skip: ev.first, limit: ev.rows}
      await $topics.load(this.load_params)
    },
    async onCopyId(id) {
      await $utils.copyText(id)
    },
    async onSearch(filter){
      if (this.load_params.filter === filter) return
      this.load_params = {skip: 0, limit: LIMIT, filter, user_id: this.user.id}
      await $topics.load(this.load_params)
      this.$refs.search.focus()
    },
    onAddTopic() {
      this.$refs.addModal.open(this.user.id)
    },
    async onNewTopic(data) {
      const payload = {
        shared_topic_id: data.chosen_topic.shared_topic_id,
        tracker_focus: data.tracker_focus,
        tracker_alerts: data.tracker_alerts,
        focus_on: data.focus_on,
        user_id: this.user.id,
      }

      try {
        await $topics.newTopic(payload)
        await $topics.load(this.load_params)
        $utils.toasts.success('User topic added successfully')
      }
      catch(err) {
        $utils.toasts.error(`Failed to add topic: ${err}`)
      }
      this.$refs.addModal.close(true)
    },
    onEditTopic(id) {
      this.$refs.editModal.open($topics.getTopic(id))
    },
    async onUpdateTopic({id, ...params}) {
      try {
        await $topics.updateTopic(id, params, this.user.id)
        await $topics.load(this.load_params)
        $utils.toasts.success('Topic updated successfully')
      }
      catch(err) {
        $utils.toasts.error(`Failed to update topic: ${err}`)
      }
      this.$refs.editModal.close(true)
    },
    async onRemoveTopic(id) {
      const comp = await $topics.getTopic(id)
      await comp.drop(this.user.id)
      await $topics.load(this.load_params)
    },
  }
}
